import {ServiceLine} from '../models/quote/service-line';
import {QuoteService} from '../models/quote/quote-service';
import {ExtraFee} from '../models/quote/extra-fee';
import {Coefficient, MultiServiceBoost} from '../../../../../rem-pct-engine/rem-pct-engine-core/src/main/ts';
import {CustomGroup} from '../models/quote/group/custom-group';
import {PricingItem} from '../models/quote/pricing-item/pricing-item';
import {EnumPricingItemType} from '../models/quote/pricing-item/pricing-item-type';
import {ConsumablePricingItem} from '../models/quote/pricing-item/consumable-pricing-item';
import {PackPricingItem} from '../models/quote/pricing-item/pack-pricing-item';
import {DevicePricingItem} from '../models/quote/pricing-item/device-pricing-item';
import {DeviceConsumablePricingItem} from '../models/quote/pricing-item/device-consumable-pricing-item';
import {DeviceConsumableWithSuppPricingItem} from '../models/quote/pricing-item/device-consumable-with-supp-pricing-item';
import {OptionPricingItem} from '../models/quote/pricing-item/option-pricing-item';
import {Corridor} from '../models/corridor/corridor';
import {Article} from '../models/quote/pricing-item/article';
import {cloneDeep} from 'lodash-es';


import {
    Article as QuoteEngineArticle,
    Corridor as QuoteEngineCorridor,
    QuoteService as QuoteEngineQuoteService,
    ServiceLine as QuoteEngineServiceLine,
    EnumCorridorColor
} from 'quote-domain-core';
import {BillingLine} from '../models/billing-line/billing-line.model';

export class EPPClientPrototypeFromQuoteEngineMapper {


    public static setServiceLinePrototype = (serviceLine: QuoteEngineServiceLine): ServiceLine => {
        let newServiceLine = Object.setPrototypeOf(cloneDeep(serviceLine), ServiceLine.prototype);

        if (serviceLine.renewalQuoteService) {
            newServiceLine = newServiceLine.copyWith({renewalQuoteService: EPPClientPrototypeFromQuoteEngineMapper.setQuoteServicePrototype(serviceLine.renewalQuoteService)});
        }
        if (serviceLine.existingQuoteService) {
            newServiceLine = newServiceLine.copyWith({existingQuoteService: EPPClientPrototypeFromQuoteEngineMapper.setQuoteServicePrototype(serviceLine.existingQuoteService)});
        }
        if (serviceLine.newQuoteService) {
            newServiceLine = newServiceLine.copyWith({newQuoteService: EPPClientPrototypeFromQuoteEngineMapper.setQuoteServicePrototype(serviceLine.newQuoteService)});
        }
        newServiceLine.billingLines && newServiceLine.billingLines.forEach((bl, index, billingLines) => {
            billingLines[index] = Object.setPrototypeOf(bl, BillingLine.prototype);
        });

        return newServiceLine;
    };

    public static setQuoteServicePrototype = (quoteService: QuoteEngineQuoteService): QuoteService => {

        let newquoteService = Object.setPrototypeOf(cloneDeep(quoteService), QuoteService.prototype);
        newquoteService.extraFees && newquoteService.extraFees.forEach((extraFee, index, extraFees) => {
            extraFees[index] = Object.setPrototypeOf(extraFee, ExtraFee.prototype);
        });
        if (newquoteService.coefficient) {
            newquoteService = newquoteService.copyWith({coefficient: Object.setPrototypeOf(newquoteService.coefficient, Coefficient.prototype)});
        }
        if (newquoteService.multiServiceBoost) {
            newquoteService = newquoteService.copyWith({multiServiceBoost: Object.setPrototypeOf(newquoteService.multiServiceBoost, MultiServiceBoost.prototype)});
        }

        newquoteService.customGroups.forEach(customGroup => {
            Object.setPrototypeOf(customGroup, CustomGroup.prototype);
            customGroup.pricingItems.forEach((pricingItem, index, pricingItems) => {
                pricingItems[index] = Object.setPrototypeOf(pricingItem, PricingItem.prototype);
                switch (pricingItems[index].pricingItemType) {
                    case EnumPricingItemType.CONSUMABLE: {
                        let consumablePricingItem: ConsumablePricingItem = Object.setPrototypeOf(pricingItem, ConsumablePricingItem.prototype);
                        pricingItems[index] = consumablePricingItem.copyWith({
                            consumable: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.consumable)
                        });
                        break;
                    }
                    case EnumPricingItemType.PACK: {
                        let packPricingItem: PackPricingItem = Object.setPrototypeOf(pricingItem, PackPricingItem.prototype);
                        pricingItems[index] = packPricingItem.copyWith({
                            device: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.device)
                        });
                        break;
                    }
                    case EnumPricingItemType.DEVICE: {
                        let devicePricingItem: DevicePricingItem = Object.setPrototypeOf(pricingItem, DevicePricingItem.prototype);
                        pricingItems[index] = devicePricingItem.copyWith({
                            device: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.device)
                        });
                        break;
                    }
                    case EnumPricingItemType.DEVICE_CONSUMABLE: {
                        let deviceConsumablePricingItem: DeviceConsumablePricingItem = Object.setPrototypeOf(pricingItem, DeviceConsumablePricingItem.prototype);
                        pricingItems[index] = deviceConsumablePricingItem.copyWith({
                            device: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.device),
                            consumable: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.consumable),
                        });
                        break;
                    }
                    case EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP: {
                        let deviceConsumableWithSuppPricingItem: DeviceConsumableWithSuppPricingItem = Object.setPrototypeOf(pricingItem, DeviceConsumableWithSuppPricingItem.prototype);
                        pricingItems[index] = deviceConsumableWithSuppPricingItem.copyWith({
                            device: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.device),
                            consumable: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.consumable),
                            deviceConsumableCorridor: this.mapQuoteEngineCorridorToCorridor(pricingItem.deviceConsumableCorridor)
                        });
                        break;
                    }
                    case EnumPricingItemType.OPTION: {
                        let optionPricingItem: OptionPricingItem = Object.setPrototypeOf(pricingItem, OptionPricingItem.prototype);
                        pricingItems[index] = optionPricingItem.copyWith({
                            option: EPPClientPrototypeFromQuoteEngineMapper.setArticlePrototype(pricingItem.option)
                        });
                        break;
                    }
                }

            });
        });
        newquoteService = newquoteService.copyWith({
            corridorDevices: this.mapQuoteEngineCorridorToCorridor(quoteService.corridorDevices),
            globalCorridorOnlyNegociable: this.mapQuoteEngineCorridorToCorridor(quoteService.globalCorridorOnlyNegociable),
            globalCorridor: this.mapQuoteEngineCorridorToCorridor(quoteService.globalCorridor),
            corridorConsumables: this.mapQuoteEngineCorridorToCorridor(quoteService.corridorConsumables),
        });
        return newquoteService;
    };

    public static setArticlePrototype(article: QuoteEngineArticle): Article {
        let newArticle = Object.setPrototypeOf(article, Article.prototype);
        return newArticle.copyWith({
            corridor: this.mapQuoteEngineCorridorToCorridor(article.corridor),
            lastCorridorState: this.mapQuoteEngineCorridorToCorridor(article.lastCorridorState)
        });
    }


    public static mapQuoteEngineCorridorToCorridor(corridor: QuoteEngineCorridor): any {

        const levels = corridor?.levels;
        if (!!levels && levels.size > 0) {
            let newCorridor = new Corridor();
            return newCorridor.copyWith( {
                pmax: levels?.get(EnumCorridorColor.GREEN)?.max,
                p90: levels?.get(EnumCorridorColor.GREEN)?.min,
                p50p90: levels?.get(EnumCorridorColor.LIGHTGREEN)?.min,
                p50: levels?.get(EnumCorridorColor.ORANGE)?.min,
                p10p50: levels?.get(EnumCorridorColor.RED)?.min,
                p10: levels?.get(EnumCorridorColor.BLACK)?.min,
                r7090: corridor?.r7090?.toString(),
                r5090: corridor?.r5090?.toString(),
                r3090: corridor?.r3090?.toString(),
                r1090: corridor?.r1090?.toString(),
                isNeutral:corridor?.isNeutral
            });
        } else {
            return null;
        }

    }
}
